<template>
  <Input
    search
    enter-button
    :placeholder="$t('search')"
    size="large"
    v-model="search"
    @on-search="searchNews"
    @on-enter="searchNews"
  />
</template>
<script>
export default {
  name: 'search',
  props: ['onEnter'],
  data() {
    return {
      search: '',
    };
  },
  methods: {
    searchNews() {
      if (this.search) {
        if (this.onEnter) {
          this.onEnter();
        }
        this.$router.push({
          name: 'search',
          query: {
            title: this.search,
          },
        });
        this.search = '';
      }
    },
  },
};
</script>
